var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-img w-full",class:_vm.border,attrs:{"title":_vm.title}},[_c('img',{staticClass:"responsive img-c",attrs:{"src":_vm.media.img,"alt":"user-profile-cover"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }